<template>
    <form-row title="Have you ordered the mortgage payoff letter?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="has_ordered_mortgage_payoff_letter"
                v-model="has_ordered_mortgage_payoff_letter"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="has_ordered_mortgage_payoff_letter"
                class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                label="Date Ordered:"
                :value="attorney.ordered_mortgage_payoff_letter_at"
                name="ordered_mortgage_payoff_letter_at"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        attorney: {},
        read_only: { default: false },
    },

    data() {
        return {
            has_ordered_mortgage_payoff_letter: this.attorney.has_ordered_mortgage_payoff_letter,
        }
    },
}
</script>
